import { useState } from 'react'

type Props = {
  onFilterChange: (start?: string, end?: string) => void
}

/**
 * 日付フィルター
 *
 * end_date を入力してフィルタリング。
 */
export function DateRangeFilter({ onFilterChange }: Props) {
  const [endDate, setEndDate] = useState('')

  const handleEndDateChange = (value: string) => {
    setEndDate(value)
    onFilterChange(undefined, value || undefined)
  }

  const handleReset = () => {
    setEndDate('')
    onFilterChange(undefined, undefined)
  }

  return (
    <div className="date-filter">
      <div className="date-filter-inputs">
        <input
          type="date"
          value={endDate}
          onChange={(e) => handleEndDateChange(e.target.value)}
          className="date-input"
          placeholder="日付を選択"
        />
      </div>

      {endDate && (
        <button onClick={handleReset} className="filter-button filter-reset">
          Reset
        </button>
      )}
    </div>
  )
}
